import { Card, CardBody, CardFooter, CardHeader, Divider } from '@heroui/react';
import { ReactNode } from 'react';

interface ReusableCardProps {
  title: string;
  subtitle?: string;
  mainContent: ReactNode;
  footerContent?: ReactNode;
  headerChip?: ReactNode;
  isFooterDevider?: boolean;
  isHeaderDevider?: boolean;
  className?: string;
}

export default function CustomCardWithHeader({
  title,
  subtitle,
  mainContent,
  footerContent,
  headerChip,
  isHeaderDevider,
  className = '',
}: ReusableCardProps) {
  return (
    <Card className={`border border-primary/80 shadow-sm ${className}`}>
      <CardHeader className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-2 flex-1 min-w-0">
          <p className="text-md font-semibold text-gray-700 truncate">
            {title}
          </p>
          {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
        </div>
        {headerChip && <div className="shrink-0">{headerChip}</div>}
        {isHeaderDevider && (
          <Divider className="absolute bottom-0 left-0 right-0" />
        )}
      </CardHeader>

      {isHeaderDevider && <div className="h-px bg-gray-100" />}

      <CardBody className="py-4">{mainContent}</CardBody>

      {footerContent && (
        <CardFooter className="flex flex-col gap-3 border-t border-gray-100">
          {footerContent}
        </CardFooter>
      )}
    </Card>
  );
}
